var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"div"},[_vm._v("213123")]),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.bindkey}},[_vm._v("点击")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }